import React from 'react'

import { IBucket } from '../../index.d'

export const BucketContext = React.createContext<IBucket | null>(null)
export const BucketProvider = BucketContext.Provider
export const BucketConsumer = BucketContext.Consumer
